import lodashGet from "lodash/get";
import React, { type ComponentPropsWithoutRef } from "react";
import { type PillarTableBaseColumnProps } from "shared/components/pillar-table/columns/PillarTableColumn";
import { usePillarTableRowContext } from "shared/components/pillar-table/row/PillarTableRowContext";

export type PillarTableColumnTextRegexProps<T> = {
  regexPattern?: string;
  regexReplace?: string;
  cellValuePath?: string;
} & PillarTableBaseColumnProps<T> &
  ComponentPropsWithoutRef<"div">;

const PillarTableColumnTextRegex = <T,>({
  cellValuePath,
  regexPattern,
  regexReplace,
}: PillarTableColumnTextRegexProps<T>) => {
  const rowContext = usePillarTableRowContext();

  const rowValue = lodashGet(
    rowContext?.rowValue,
    cellValuePath ?? "",
  ) as unknown as string;

  if (!(regexPattern && regexReplace) || !rowValue) {
    return <></>;
  }
  const cleanPattern = regexPattern.slice(1, -1).replace(/\\\\/g, "\\");
  const regex = new RegExp(cleanPattern);

  return <>{rowValue.replace(regex, regexReplace)}</>;
};

export default PillarTableColumnTextRegex;
